import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import failureImg from "../../Assets/Payment_Assets/error_illustration.jpg";

const Failure = () => {
  const navigate = useNavigate();
  const [isJuridentPayment, setIsJuridentPayment] = useState(false);
  const [redirecting, setRedirecting] = useState(true);

  useEffect(() => {
    console.log('🔍 [Failure Page] Checking payment type...');

    // Check localStorage for Jurident payment context
    const paymentContextStr = localStorage.getItem('jurident_payment_context');

    if (paymentContextStr) {
      try {
        const paymentContext = JSON.parse(paymentContextStr);
        console.log('📦 [Failure Page] Found Jurident payment context in localStorage:', paymentContext);

        // Verify this is a recent payment (within last 30 minutes)
        const ageMinutes = (Date.now() - paymentContext.timestamp) / 1000 / 60;
        console.log('⏱️  [Failure Page] Payment context age:', Math.round(ageMinutes), 'minutes');

        if (ageMinutes < 30) {
          console.log('✅ [Failure Page] Valid Jurident payment detected, redirecting...');
          setIsJuridentPayment(true);

          // Build redirect URL with payment data
          const params = new URLSearchParams({
            userId: paymentContext.userId,
            transactionId: paymentContext.transactionId,
            amount: paymentContext.amount,
            category: paymentContext.category,
            phoneNo: paymentContext.phoneNo,
            userName: paymentContext.userName || 'User',
            platform: paymentContext.platform
          });

          const juridentFailureUrl = `/jurident-payment/failure?${params.toString()}`;
          console.log('🔄 [Failure Page] Redirecting to:', juridentFailureUrl);

          // Clean up localStorage
          localStorage.removeItem('jurident_payment_context');
          console.log('🧹 [Failure Page] Cleaned up payment context from localStorage');

          // Redirect after a brief moment
          setTimeout(() => {
            navigate(juridentFailureUrl);
          }, 500);

          return;
        } else {
          console.log('⚠️  [Failure Page] Payment context expired, cleaning up...');
          localStorage.removeItem('jurident_payment_context');
        }
      } catch (error) {
        console.error('❌ [Failure Page] Error parsing payment context:', error);
        localStorage.removeItem('jurident_payment_context');
      }
    }

    // Fallback: Check URL parameters for transaction ID
    const params = new URLSearchParams(window.location.search);
    const transactionId = params.get('transactionId') || params.get('merchantTransactionId');

    console.log('🔍 [Failure Page] Checking URL parameters...');
    console.log('Transaction ID from URL:', transactionId);

    // Jurident transaction IDs start with 'T' followed by timestamp
    if (transactionId && transactionId.startsWith('T') && transactionId.length > 10) {
      console.log('✅ [Failure Page] Detected Jurident payment from URL, redirecting...');
      setIsJuridentPayment(true);

      // Get all URL parameters to forward them
      const urlParams = window.location.search;

      // Redirect to Jurident failure page with all parameters
      const juridentFailureUrl = `/jurident-payment/failure${urlParams}`;
      console.log('🔄 [Failure Page] Redirecting to:', juridentFailureUrl);

      // Redirect after a brief moment
      setTimeout(() => {
        navigate(juridentFailureUrl);
      }, 500);
    } else {
      console.log('✅ [Failure Page] Regular course/WhatsApp payment failure');
      setRedirecting(false);
    }
  }, [navigate]);

  // Show loading state while redirecting
  if (isJuridentPayment && redirecting) {
    return (
      <section
        className="payment_container"
        style={{ backgroundColor: "#F9F9EFff" }}
      >
        <h1>Payment Failed</h1>
        <h2>Redirecting...</h2>
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #dc3545',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '20px auto'
        }}></div>
      </section>
    );
  }

  // Regular course/WhatsApp payment failure page
  return (
    <section
      className="payment_container"
      style={{ backgroundColor: "#F9F9EFff" }}
    >
      <div className="illustation_container">
        <img src={failureImg} alt="" />
      </div>
      <h1>oops! payment failed</h1>
      <h2>something went wrong try again later</h2>
      <Link to="/Courses">Back to Courses</Link>
    </section>
  );
};

export default Failure;
